'use client';
import React, { useState } from 'react';

interface TextAreaProps {
  placeholder?: string;
  value?: string;
  onChange?: (value: string) => void;
  disabled?: boolean;
  required?: boolean;
  className?: string;
  name?: string;
  id?: string;
  rows?: number;
  cols?: number;
  maxLength?: number;
  minLength?: number;
  resize?: 'none' | 'both' | 'horizontal' | 'vertical';
}

const TextArea: React.FC<TextAreaProps & React.TextareaHTMLAttributes<HTMLTextAreaElement>> = ({
  placeholder = '',
  value,
  onChange,
  disabled = false,
  required = false,
  className = '',
  name,
  id,
  rows = 4,
  cols,
  maxLength,
  minLength,
  resize = 'vertical',
  ...props
}) => {
  const [internalValue, setInternalValue] = useState(value || '');
  const [isFocused, setIsFocused] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const newValue = e.target.value;
    setInternalValue(newValue);
    if (onChange) {
      onChange(newValue);
    }
  };

  const handleFocus = () => {
    setIsFocused(true);
  };

  const handleBlur = () => {
    setIsFocused(false);
  };

  const resizeClasses = {
    none: 'resize-none',
    both: 'resize',
    horizontal: 'resize-x',
    vertical: 'resize-y'
  };

  return (
    <div data-component-id="src/components/ui/TextArea.tsx:63:4" data-component-path="src/components/ui/TextArea.tsx" data-component-line="63" data-component-file="TextArea.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22w-full%20mb-%5B4px%5D%22%7D" className="w-full mb-[4px]">
      <textarea data-component-id="src/components/ui/TextArea.tsx:64:6" data-component-path="src/components/ui/TextArea.tsx" data-component-line="64" data-component-file="TextArea.tsx" data-component-name="textarea" data-component-content="%7B%22elementName%22%3A%22textarea%22%2C%22name%22%3A%22%5Bvar%3Aname%5D%22%2C%22id%22%3A%22%5Bvar%3Aid%5D%22%2C%22%5Bspread%5D%22%3A%22true%22%7D"
        value={value !== undefined ? value : internalValue}
        onChange={handleChange}
        onFocus={handleFocus}
        onBlur={handleBlur}
        placeholder={placeholder}
        disabled={disabled}
        required={required}
        name={name}
        id={id}
        rows={rows}
        cols={cols}
        maxLength={maxLength}
        minLength={minLength}
        className={`
          w-full
          bg-textarea-1
          text-textarea-1
          text-[16px] font-inter font-normal leading-[20px] text-left
          pt-[10px] pr-[16px] pb-[10px] pl-[16px]
          rounded-[6px]
          border-0
          focus:outline-none
          focus:ring-2
          focus:ring-global-1
          focus:ring-opacity-50
          placeholder:text-textarea-1
          placeholder:opacity-70
          transition-all
          duration-200
          ease-in-out
          ${resizeClasses[resize]}
          ${isFocused ? 'ring-2 ring-global-1 ring-opacity-50' : ''}
          ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-text'}
          min-h-[100px] sm:min-h-[120px]
          touch-manipulation
          ${className}
        `.trim().replace(/\s+/g, ' ')}
        {...props}
      />
    </div>
  );
};

export default TextArea;